import React, { useState } from 'react';
import { AgCharts } from 'ag-charts-react';
import { Select, Space, Modal, Button } from 'antd';
import { ExpandAltOutlined } from '@ant-design/icons';
import { SiteModelAccuracyChartLogic } from './SiteModelAccuracyChart';
import './SiteModelAccuracyChart.scss';
import {
    ClientSideRowModelModule,
    MasterDetailModule,
    ModuleRegistry,
} from 'ag-grid-enterprise';

ModuleRegistry.registerModules([ClientSideRowModelModule, MasterDetailModule]);

function SiteModelAccuracyChart({ startAndEndUnixDatesParams = '', hideUnknowns = false }) {
    const { 
        modelAccuracyConfig, 
        selectedDeployment, 
        getDeploymentOptions,
        filterOption,
        handleDeploymentChange
    } = SiteModelAccuracyChartLogic(startAndEndUnixDatesParams, hideUnknowns);
    const [modalOpen, setModalOpen] = useState(false);

    return (
        <div className='site-model-accuracy-chart-wrapper'>
            <div className='header'>
                <h2>Model Accuracy Chart (Last 30 Days)</h2>
                {/* <Space.Compact className='site-model-dropdown'>
                    <Select
                        className='site-model-select'
                        placeholder="Showing All Sites"
                        allowClear
                        showSearch
                        filterOption={filterOption}
                        value={selectedDeployment}
                        onChange={handleDeploymentChange}
                        options={getDeploymentOptions()}
                        optionLabelProp="label"
                        style={{ width: 300 }}
                    />
                </Space.Compact> */}
            </div>
            <div className='chart-container'>
                <div className='model-accuracy-chart'>
                    <Button
                        className='model-accuracy-chart-expand-btn'
                        type='text'
                        size='small'
                        icon={<ExpandAltOutlined />}
                        onClick={() => setModalOpen(true)}
                    />
                    {modelAccuracyConfig && <AgCharts options={modelAccuracyConfig} />}
                </div>
            </div>
            <Modal
                centered
                open={modalOpen}
                onCancel={() => setModalOpen(false)}
                footer={null}
                width='90%'
            >
                {modelAccuracyConfig && <AgCharts options={modelAccuracyConfig} style={{ height: '70vh' }} />}
            </Modal>
        </div>
    )
}

export default SiteModelAccuracyChart
